/* eslint-disable */
import React, { useState, useEffect, useCallback } from "react";
/* Components */
import Button from "../button/button";
import { Controller, useForm } from "react-hook-form";
//import { getInstitutions } from '../../services/institution';
import { useMutation } from "react-query";
import {
  authRegister,
  authLoginSocialMedia,
} from "../../services/auth.service";
import useSnackbarStore from "../../store/snackbarStore";
import { useMixPanel } from "../../hooks/useMixPanel";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MIX_PANEL_EVENTS } from "../../utils/constans";
import useSessionStore from "../../store/useSessionStore";
import GoogleSign from "../google/GoogleSign";
import ReactSelect from "react-select";
import {
  getInstitutionsByName,
  storeInstitution,
} from "../../services/institution";
import debounce from "lodash.debounce";
import AsyncSelect from "react-select/async";
import ModalForm from "../form-elements/modal-form/modalForm";
import {
  getCityByCountryAndRegion,
  getCountries,
  getRegionByCountry,
} from "../../services/location.service";

const SignUpForm = ({ onSignIn }) => {
  const [loading, setLoading] = useState(false);
  const [regions, setRegions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [institutionRegions, setInstitutionsRegions] = useState([]);
  const [institutionCountries, setInstitutionsCountries] = useState([]);
  const [institutionCities, setInstitutionsCities] = useState([]);

  const { show } = useSnackbarStore();
  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      country: "",
      country_code: "",
      city: "",
    },
    mode: "onChange",
  });

  const { setInitialEvent } = useMixPanel();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [currentStep, setCurrentStep] = useState(1);

  const [searchTerm, setSearchTerm] = useState("");
  const [, setDebouncedSearchTerm] = useState("");
  const selectedCountryCode = watch("country_code");
  const selectedRegion = watch("region_id");
  const selectedCity = watch("city_id");
  const selectedInstitutionCountry = watch("country_institution");
  const selectedInstitutionRegion = watch("region_institution");
  const selectedInstitutionCity = watch("city_institution");
  const email = watch("email");
  const first_name = watch("first_name");
  const last_name = watch("last_name");
  const country = watch("country_code");
  const institution = watch("institution");
  const newInstitution = watch("newInstitution");
  const [showModal, setShowModal] = useState(false);

  const { setUser, setNewUserGoogle, setClearUserGoogle } = useSessionStore();

  // Actualiza debouncedSearchTerm después de que el usuario deja de escribir
  useEffect(() => {
    // Crea una función debounced que actualiza debouncedSearchTerm
    const debouncedUpdate = debounce((search) => {
      setDebouncedSearchTerm(search);
    }, 500); // 500 ms de espera

    if (searchTerm) {
      debouncedUpdate(searchTerm);
    }

    // Limpia el debounce si el componente se desmonta o el searchTerm cambia
    return () => debouncedUpdate.cancel();
    // eslint-disable-next-line
  }, [searchTerm]);

  // eslint-disable-next-line
  const debouncedLoadOptions = useCallback(
    debounce((inputValue, callback) => {
      if (!inputValue) {
        callback([]);
        return;
      }

      // useCallback para memorizar la función debounced
      getInstitutionsByName(inputValue).then((institutions) => {
        const options = institutions.map((institution) => ({
          label: institution.name,
          value: institution.id,
        }));
        if (options.length === 0) {
          // Si no hay opciones, muestra el modal
          setShowModal(true);
          setValue("newInstitution", inputValue);
        } else {
          setValue("newInstitution", "");
          // Si hay opciones, asegúrate de que el modal no se muestre
          setShowModal(false);
        }
        callback(options);
      });
    }, 1000),
    []
  );
  // eslint-disable-next-line
  const loadInstitutionOptions = (inputValue, callback) => {
    debouncedLoadOptions(inputValue, callback);
  };

  const nextStep = async () => {
    const dataLocalUser = {
      user: {
        email,
        first_name,
        last_name,
        country,
        institution,
      },
    };
    switch (currentStep) {
      case 1:
        setInitialEvent(dataLocalUser, MIX_PANEL_EVENTS.registerNativeStep1);
        break;
      case 2:
        setInitialEvent(dataLocalUser, MIX_PANEL_EVENTS.registerNativeStep2);
        break;
      case 3:
        setInitialEvent(dataLocalUser, MIX_PANEL_EVENTS.registerNativeStep3);
        break;
      default:
        break;
    }

    const stepFields = {
      1: ["terms", "data_processing"], // Asume estos campos para el paso 1
      2: ["first_name", "last_name", "email", "password"], // Asume estos campos para el paso 2
      3: ["institution", "country", "city"], // Asume estos campos para el paso 3
    };
    const currentFields = stepFields[currentStep];
    const result = await trigger(currentFields);
    if (result) {
      setCurrentStep(currentStep + 1);
    } else {
      console.error("Campos faltantes");
    }
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  useEffect(() => {
    if (selectedCountryCode) {
      mutationRegions.mutate({ country: selectedCountryCode, lang: i18n.language });
    }
    // eslint-disable-next-line
  }, [selectedCountryCode, setValue]);

  useEffect(() => {
    if (selectedRegion) {
      mutationCity.mutate({
        country: selectedCountryCode,
        region: selectedRegion,
        lang: i18n.language
      });
    }
    // eslint-disable-next-line
  }, [selectedRegion]);

  // useEffect(() => {
  //   if (selectedInstitutionCountry) {
  //     mutationInstitutionRegions.mutate({ country: selectedInstitutionCountry, lang: i18n.language });
  //   }
  //   // eslint-disable-next-line
  // }, [selectedInstitutionCountry]);

  useEffect(() => {
    if (selectedInstitutionRegion) {
      mutationInstitutionCity.mutate({
        country: selectedInstitutionCountry,
        region: selectedInstitutionRegion,
        lang: i18n.language
      });
    }
    // eslint-disable-next-line
  }, [selectedInstitutionRegion]);

  useEffect(() => {
    if (showModal) {
      mutationInstitutionCountries.mutate(i18n.language);
    }
    // eslint-disable-next-line
  }, [showModal]);

  useEffect(() => {
    mutationCountries.mutate(i18n.language);
    // eslint-disable-next-line
  }, []);

  const onSubmit = (form) => {
    setLoading(true);
    mutation.mutate({
      ...form,
      country: selectedCountryCode,
      state: selectedRegion,
      city: selectedCity,
      institution: form.institution.value,
    });
  };

  const mutation = useMutation(authRegister, {
    onSuccess: (data) => {
      setUser(data?.user);
      setInitialEvent(data, MIX_PANEL_EVENTS.register);
      show(t("usuario_registrado_mensaje_correo"), "success", 10000);
      setLoading(false);
      navigate("/");
    },
    onError: (error) => {
      if (error?.response.status === 401) {
        show(error.response.data.message, "error");
      }
      setLoading(false);
    },
  });

  const mutationCountries = useMutation(getCountries, {
    onSuccess: (data) => {
      const countryOptions = data.map((country) => ({
        value: country.country_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setCountries(countryOptions);
      setInstitutionsCountries(countryOptions);
    },
    onError: (error) => {},
  });

  const mutationInstitutionCountries = useMutation(getCountries, {
    onSuccess: (data) => {
      const countryOptions = data.map((country) => ({
        value: country.country_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setInstitutionsCountries(countryOptions);
    },
    onError: (error) => {},
  });

  const mutationRegions = useMutation(getRegionByCountry, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.region_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setRegions(options);
      setInstitutionsRegions(options);
    },
    onError: (error) => {},
  });

  const mutationInstitutionRegions = useMutation(getRegionByCountry, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.region_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setInstitutionsRegions(options);
    },
    onError: (error) => {},
  });

  const mutationCity = useMutation(getCityByCountryAndRegion, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.city_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setCities(options);
      setInstitutionsCities(options);
    },
    onError: (error) => {},
  });

  const mutationInstitutionCity = useMutation(getCityByCountryAndRegion, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.city_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setInstitutionsCities(options);
    },
    onError: (error) => {},
  });

  const mutationSocialMedia = useMutation(authLoginSocialMedia, {
    onSuccess: (data) => {
      if (data?.user?.isNew) {
        setInitialEvent(data, MIX_PANEL_EVENTS.registerGoogle);
        setNewUserGoogle(true);
        navigate("/");
      } else {
        setInitialEvent(data, MIX_PANEL_EVENTS.loginGoogle);
        setNewUserGoogle(false);
        navigate("/");
      }
      setUser(data?.user);
      setLoading(false);
    },
    onError: (error) => {
      if (error?.response.status === 401) {
        show(error.response.data.message, "error");
      }
      setLoading(false);
      setClearUserGoogle();
    },
  });

  const mutationStoreInstitution = useMutation(storeInstitution, {
    onSuccess: (data) => {
      getInstitutionsByName(data?.name).then((institutions) => {
        if (institutions.length > 0) {
          const newInstitution = institutions[0];
          setValue(
            "institution",
            { label: newInstitution.name, value: newInstitution.id },
            { shouldValidate: true }
          );
          setShowModal(false);
        }
      });
    },
    onError: (error) => {
      console.log("Error al registrar la institución", error);
      // Maneja el error según sea necesario
    },
  });

  const SelectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "rgb(182 182 182 / 0.5)",
      borderColor: "transparent",
      borderRadius: "8px",
      caretColor: "white",
      "&:hover": { borderColor: "transparent" }, // Borde en hover
    }),
    input: (provided) => ({
      ...provided,
      color: "rgb(38, 38, 38)",
      fontWeight: "bold", // Establece el color del texto del input a blanco
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#F2F2F2" : "#FEFEFE",
      color: "black",
      cursor: "pointer",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#FEFEFE", // Color del indicador
      "&:hover": {
        color: "#3FB2E3", // Color del indicador en hover
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "rgb(38, 38, 38)", // Establece el color del texto de la opción seleccionada a blanco
      fontWeight: "bold",
    }),
    clearIndicator: (styles) => ({
      ...styles,
      color: 'black', // Aquí puedes poner el color que desees
      ':hover': {
        color: 'black', // Color cuando se pasa el ratón por encima (hover)
      },
    }),
  };

  // const insTypeOptions = [
  //   { label: "Colegio", value: "Colegio" },
  //   { label: "Gimnasio", value: "Gimnasio" },
  //   { label: "Liceo", value: "Liceo" },
  //   { label: "IED", value: "IED" },
  //   { label: "Jardín infantil", value: "Jardín infantil" },
  // ];

  const onGoogleSuccess = (event) => {
    mutationSocialMedia.mutate({
      email: event?.email,
      first_name: event?.given_name,
      last_name: event?.family_name,
    });
  };

  const onGoogleError = (event) => {
    console.log("onGoogleError event ", event);
  };

  const handleRegister = () => {
    handleSubmit(onSubmit)();
  };

  const handleRegisterInstitution = () => {
    const payload = {
      name: newInstitution,
      country: selectedInstitutionCountry,
      state: selectedInstitutionRegion,
      city: selectedInstitutionCity,
    };
    mutationStoreInstitution.mutate(payload);
  };

  return (
    <div className="flex flex-col gap-2 sm-max:order-2">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={`sign-up${currentStep > 1 ? " step-2-h" : ""}`}
      >
        <h2 className="alt-h1 w-full text-center">{t("register")}</h2>
        <div className="w-full flex-1">
          {/* Step 1 */}
          <div className={`${currentStep === 1 ? "flex" : "hidden"} flex-col`}>
            <div className="flex flex-col px-4 sm-max:px-2">
              <h6 className="text-shaiaBlue text-center mb-4">
                {t("registroTextoBienvenida")}
              </h6>
              <p className="dark:text-Grey-500 text-DarkBlue-500 text-center">
                {t("registroTextoInstruccion")}
              </p>
            </div>
            <div className="flex flex-col items-center justify-center sm-max:gap-2 sm-max:pb-4">
              <div className="sso-wrapper flex-1 md:max-w-1/2">
                <GoogleSign
                  onSuccess={onGoogleSuccess}
                  onError={onGoogleError}
                />
              </div>
              <div className="login-divider w-[90%]">
                <hr className="divider-hr"></hr>
                <span className="">o</span>
                <hr className="divider-hr"></hr>
              </div>
              <Button
                label={t("registroTextoBotonCorreo")}
                variant="primary"
                onClick={nextStep}
                customClassName="!h-10 !py-3.5 flex-1 md:max-w-70/100"
              />
              <p className="dark:text-Grey-500 text-DarkBlue-500 text-center px-4 sm-max:px-2 mb-0 mt-4">
                {t("aceptacionTerminos")}
              </p>
              <div className="input-row mt-0 mb-6 px-3 gap-2">
                <div className="input-text mt-2 flex-1">
                  <label
                    htmlFor="terms"
                    className="w-full flex flex-row justify-center gap-1 dark:text-Grey-500 text-DarkBlue-500 text-3.5 font-bold"
                  >
                    <input
                      type="checkbox"
                      id="terms"
                      {...register("terms", { required: t("campo_requerido") })}
                    />
                    <span>
                      {t("acepatcionTerminos_check1")}
                      <a
                        href="https://www.mentu.la/tratamiento-de-datos"
                        className="underline text-shaiaBlue"
                      >
                        {t("acepatcionTerminos_check1a")}
                      </a>
                    </span>
                  </label>
                  {errors.terms && (
                    <span className="error">{errors.terms.message}</span>
                  )}
                </div>
                <div className="input-text mt-2 flex-1">
                  <label
                    htmlFor="data_processing"
                    className="w-full flex flex-row justify-center gap-1 dark:text-Grey-500 text-DarkBlue-500 text-3.5 font-bold"
                  >
                    <input
                      type="checkbox"
                      id="data_processing"
                      {...register("data_processing", {
                        required: t("campo_requerido"),
                      })}
                    />
                    <span>
                      {t("acepatcionTerminos_check2")}
                      <a
                        href="https://www.mentu.la/autorizacion-de-tratamiento-de-datos"
                        className="underline text-shaiaBlue"
                      >
                        {t("acepatcionTerminos_check2a")}
                      </a>
                    </span>
                  </label>
                  {errors.data_processing && (
                    <span className="error">
                      {errors.data_processing.message}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Step 2 */}
          <div className={`${currentStep === 2 ? "flex" : "hidden"} flex-col`}>
            <label className="input-label label-alt">
              {t("registroNativoTitulo_step1")}
            </label>
            <div className="input-row">
              <div className="input-text">
                <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                  {t("firstName")}(s):
                </label>
                <input
                  className="input-box"
                  type="text"
                  {...register("first_name", {
                    required: t("requiredFirstName"),
                  })}
                />
                {errors.first_name && (
                  <span className="error">{errors.first_name.message}</span>
                )}
              </div>
              <div className="input-text">
                <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                  {t("lastName")}(s):
                </label>
                <input
                  className="input-box"
                  type="text"
                  {...register("last_name", {
                    required: t("requiredLastName"),
                  })}
                />
                {errors.last_name && (
                  <span className="error">{errors.last_name.message}</span>
                )}
              </div>
            </div>
            <div className="input-text mt-2">
              <label className="input-label dark:text-Grey-500 text-DarkBlue-500">{t("email")}:</label>
              <input
                className="input-box"
                type="email"
                {...register("email", {
                  required: t("requiredEmail"),
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: t("notValidEmail"),
                  },
                })}
              />
              {errors.email && (
                <span className="error">{errors.email.message}</span>
              )}
            </div>
            <div className="input-text mt-2">
              <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                {t("password")}:
              </label>
              <input
                className="input-box"
                type="password"
                {...register("password", { required: t("requiredPassword") })}
              />
              {errors.password && (
                <span className="error">{errors.password.message}</span>
              )}
            </div>

            {/* <div className="input-text mt-2">
              <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                {t("institution")}
              </label>
              <input
                className="input-box"
                type="text"
                {...register("institution", { required: t("campo_requerido") })}
              />
              {errors.institution && (
                <span className="error">{errors.institution.message}</span>
              )}
            </div> */}

            <div className="input-row">
              <div className="input-text mt-2 flex-1">
                {/* Selector de País */}
                <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                  {t("registro_qPais")}
                </label>
                <Controller
                  name="country_code"
                  control={control}
                  rules={{ required: t("campo_requerido") }}
                  render={({ field }) => (
                    <ReactSelect
                      {...field}
                      value={countries.find(
                        (option) => option.value === field.value
                      )}
                      options={countries}
                      placeholder={t("seleccionar_pais")}
                      onChange={(option) => {
                          if(option === null){
                            setValue("country_code", null);
                          }
                        field.onChange(option?.value);
                      }}
                      styles={SelectStyles}
                      isMulti={false}
                      maxMenuHeight={100}
                      menuPlacement="bottom"
                      isClearable
                    />
                  )}
                />
                {errors.country_code && (
                  <span className="error">{errors.country_code.message}</span>
                )}
              </div>

              {/* <div className="input-text mt-2 flex-1">
      
                <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                  {t("registro_qEstado")}
                </label>
                <Controller
                  name="region_id"
                  control={control}
                  rules={{ required: t("campo_requerido") }}
                  disabled={!selectedCountryCode && !regions.length}
                  render={({ field }) => (
                    <ReactSelect
                      {...field}
                      value={regions.find(
                        (option) => option.value === field.value
                      )}
                      options={regions}
                      placeholder={"Seleccionar Estado"}
                      onChange={(option) => {
                        if (typeof option === "object" && option !== null) {
                          setValue("region_institution", option.value);
                          field.onChange(option.value);
                        }
                      }}
                      styles={SelectStyles}
                      isMulti={false}
                      maxMenuHeight={100}
                      menuPlacement="bottom"
                    />
                  )}
                />
                {errors.country_code && (
                  <span className="error">{errors.country_code.message}</span>
                )}
              </div> */}
            </div>
            {/* <div className="input-row">
              <div className="input-text mt-2 flex-1">
            
                <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                  {t("registro_qCiudad")}
                </label>
                <Controller
                  name="city_id"
                  control={control}
                  rules={{ required: t("campo_requerido") }}
                  render={({ field }) => (
                    <ReactSelect
                      {...field}
                      value={cities.find(
                        (option) => option.value === field.value
                      )}
                      options={cities}
                      placeholder={t("seleccionar_ciudad")}
                      onChange={(option) => {
                        if (typeof option === "object" && option !== null) {
                          setValue("city_institution", option.value);
                          field.onChange(option.value);
                        }
                      }}
                      styles={SelectStyles}
                      isMulti={false}
                      maxMenuHeight="200px"
                      menuPlacement="bottom"
                    />
                  )}
                />
                {errors.city_id && (
                  <span className="error">{errors.city_id.message}</span>
                )}
              </div>
            </div> */}

            {/* Sustituir con nueva funcionalidad de instituciones */}
            <div className="input-text mt-2">
              <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                {t("institution")}
              </label>
              <Controller
                name="institution"
                control={control}
                rules={{ required: t("campo_requerido") }}
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    cacheOptions
                    defaultOptions
                    loadOptions={loadInstitutionOptions}
                    onInputChange={(value) => {
                      setSearchTerm(value); // Actualiza el término de búsqueda basado en la entrada del usuario
                    }}
                    onChange={(selectedOption) => {
                      if (typeof selectedOption === "object" && selectedOption !== null) {   
                        setValue("institution", selectedOption, {
                          shouldValidate: true,
                        }); 
                      } else {
                        setValue("institution", null);
                      }
                      field.onChange(selectedOption);
                    }}
                    value={field.value} // Valor seleccionado se muestre correctamente
                    styles={SelectStyles}
                    placeholder={t("registro_campo_institution_placeholder")}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    isClearable
                    backspaceRemovesValue
                  />
                )}
              />

              {errors.institution && (
                <span className="error">{errors.institution.message}</span>
              )}

              <ModalForm isOpen={showModal}>
                <form className="!bg-transparent !w-full !h-full !border-none">
                  {/* <div className='input-text mt-2'>
                    <label className="input-label dark:text-Grey-500 text-DarkBlue-500">Selecciona el tipo de institución</label>
                    <Controller
                      name="institution"
                      control={control}
                      render={({ field }) => (
                        <CheckboxGroup
                          field={field}
                          options={insTypeOptions}
                          inputView={false}
                        />
                      )}
                    />
                  </div> */}
                  <label className="input-label label-alt">
                    {t("registro_creacion_institucion")}
                  </label>
                  <div className="input-row">
                    <div className="input-text mt-2 flex-1">
                      {/* Selector de País */}
                      <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                        {t("registro_campo_pais_titulo")}
                      </label>
                      <Controller
                        name="country_institution"
                        control={control}
                        rules={{ required: showModal ? t("campo_requerido") : false }}
                        render={({ field }) => (
                          <ReactSelect
                            {...field}
                            value={institutionCountries.find(
                              (option) => option.value === field.value
                            )}
                            options={institutionCountries}
                            placeholder={t("seleccionar_pais")}
                            onChange={(option) => {
                              if (typeof option === "object" && option !== null) {
                                setValue("country_institution", option.value,{
                                  shouldValidate: true,
                                });
                              } else {
                                setValue("country_institution", null, {
                                  shouldValidate: true,
                              });
                              }
                              field.onChange(option?.value);
                            }}
                            styles={SelectStyles}
                            isMulti={false}
                            maxMenuHeight={200}
                            menuPlacement="bottom"
                            isClearable
                            backspaceRemovesValue
                          />
                        )}
                      />
                      {errors.country_institution && (
                        <span className="error">
                          {errors.country_institution.message}
                        </span>
                      )}
                    </div>

                    {/* <div className="input-text mt-2 flex-1">
                  
                      <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                        {t("registro_campo_estado_titulo")}
                      </label>
                      <Controller
                        name="region_institution"
                        control={control}
                        rules={{ required: showModal ? t("campo_requerido") : false }}
                        disabled={
                          !selectedInstitutionCountry &&
                          !institutionRegions.length
                        }
                        render={({ field }) => (
                          <ReactSelect
                            {...field}
                            value={institutionRegions.find(
                              (option) => option.value === field.value
                            )}
                            options={institutionRegions}
                            placeholder={t("registro_campo_seleccione")}
                            onChange={(option) => {
                              if (
                                typeof option === "object" &&
                                option !== null
                              ) {
                                field.onChange(option.value);
                              }
                            }}
                            styles={SelectStyles}
                            isMulti={false}
                            maxMenuHeight={200}
                            menuPlacement="bottom"
                          />
                        )}
                      />
                      {errors.region_institution && (
                        <span className="error">
                          {errors.region_institution.message}
                        </span>
                      )}
                    </div> */}
                  </div>
                  {/* <div className="input-row">
                    <div className="input-text mt-2 flex-1">
                      
                      <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                        {t("registro_campo_ciudad_titulo")}
                      </label>
                      <Controller
                        name="city_institution"
                        control={control}
                        rules={{ required: showModal ? t("campo_requerido") : false }}
                        render={({ field }) => (
                          <ReactSelect
                            {...field}
                            value={institutionCities.find(
                              (option) => option.value === field.value
                            )}
                            disabled={
                              !selectedInstitutionRegion &&
                              !institutionCities.length
                            }
                            options={institutionCities}
                            placeholder={t("registro_campo_seleccione")}
                            onChange={(option) => field.onChange(option.value)}
                            styles={SelectStyles}
                            isMulti={false}
                            maxMenuHeight="200px"
                            menuPlacement="bottom"
                          />
                        )}
                      />
                      {errors.city_institution && (
                        <span className="error">
                          {errors.city_institution.message}
                        </span>
                      )}
                    </div>
                  </div> */}
                  <div className="input-text mt-2">
                    <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                      {t("registro_campo_institution_nombre")}
                    </label>
                    <input
                      className="input-box"
                      type="text"
                      {...register("newInstitution", {
                        required: showModal ? t("campo_requerido") : false,
                      })}
                    />
                  </div>
                  {/* Improvement */}
                  {/* <div className="input-text mt-2">
                    <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                    {t("registro_campo_institution_sede")}
                    </label>
                    <input
                      className="input-box"
                      type="text"
                      {...register("newInstitutionHeadquartered")}
                    />
                  </div> */}
                  <Button
                    label={t("registro_campo_institution_boton")}
                    variant="primary"
                    customClassName="mt-6 bg-LightBlue-500"
                    typeB="button"
                    onClick={() => handleRegisterInstitution()}
                  />
                </form>
              </ModalForm>
            </div>
          </div>
        </div>
      </form>
      <div className="step-buttons">
        {currentStep > 1 && (
          <Button
            label="Anterior"
            variant="primary-outline"
            onClick={prevStep}
            customClassName="prev-btn"
          />
        )}
        {currentStep === 2 && (
          <Button
            label={loading ? t("creatingUser") : t("createUser")}
            variant="secondary"
            onClick={handleRegister}
            customClassName="sm-max:py-2.5"
          />
        )}
      </div>
    </div>
  );
};

export default SignUpForm;
